module.exports = require("tty");


/*****************
 ** WEBPACK FOOTER
 ** external "tty"
 ** module id = 336
 ** module chunks = 0
 **/